import { hideableValueCreateHidden } from "@wix/devzai-utils-common";
import type { HideableValue } from "@wix/devzai-utils-common";
import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import type {BymoPageHasSearchProps, BymoPageSocialLinksProps} from '../../../client-server-common';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    BymoPagePropsSpecialContentSettingMetadata,
    BymoPageSocialLinksButtonStyle,
    BymoPageSocialLinksColorMode,
    BymoPageSocialLinksIconType,
    BymoPageSocialLinksSize,
    bymoPagePropsCreateContentSettingMetadata
} from '../../../client-server-common';
import {doppeActionButtonTemplateGetSocialLinksDefault} from '../../../client-server-common/doppe-templates/doppe-action-button-template-utils';
import {
    BymoTemplateSpeedDialActionsListAppearance,
    BymoTemplateSpeedDialAutoComplete,
    BymoTemplateSpeedDialHeaderAppearance,
    BymoTemplateSpeedDialSearchAppearance,
    BymoTemplateSpeedDialSocialLinksAppearance
} from './bymo-template-speed-dial-common';

export namespace BymoTemplateSpeedDial {

    export interface TemplateProps extends BymoPageSocialLinksProps , BymoPageHasSearchProps {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        actionsHeading: HideableValue<string>;
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance;
        bioText: HideableValue<string>;
        bioTextMaxLines: HideableValue<number>;
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance;
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance;
    }
}

const TemplatePropsDefaultValues = () => {
    return {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch as BymoTemplateSpeedDialAutoComplete,
        showFullScreenAutoCompleteOnMobile: false,
        actionsHeading: '',
        bioText: '',
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance.Visible as BymoTemplateSpeedDialActionsListAppearance,

        socialLinks: [],
        socialLinksIconType: BymoPageSocialLinksIconType.Default,
        socialLinksButtonStyle: BymoPageSocialLinksButtonStyle.Plain,
        socialLinksCustomActionButtonTemplate: doppeActionButtonTemplateGetSocialLinksDefault(),
        socialLinksSize: BymoPageSocialLinksSize.Medium,
        socialLinksColorMode: BymoPageSocialLinksColorMode.TextColor,
        bioTextMaxLines: hideableValueCreateHidden(3),
        searchAppearance: BymoTemplateSpeedDialSearchAppearance.Hidden ,
        searchPlaceholder: hideableValueCreateHidden(""),
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance.Default ,
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default ,
    } as BymoTemplateSpeedDial.TemplateProps;
}


export const BymoTemplateSpeedDialTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateSpeedDial.TemplateProps>()({
    initialValues: TemplatePropsDefaultValues(),
    resolveProps: props => {
      const {
            ...restProps
        } = props;

        return {
            ...TemplatePropsDefaultValues(),
            socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default,
            ...restProps
        }
    },
    templatePropsMetadata: {
        bioText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        actionsHeading: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        searchPlaceholder: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        bioTextMaxLines: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showFullScreenAutoCompleteOnMobile: BymoPagePropsSpecialContentSettingMetadata.Ignored,
    },
    features: [
        'hasActionButton',
        'hasProfileContent',
        'hasVisibleBackground',
        'hasCustomTextualContent',
        'hasActions',        // ✅ Single-page support
        'canBeSkipped',
    ]
})